const fr = {
  general: {
    emailAddress: "adresse e-mail",
    phoneNumber: "numéro de téléphone",
    error: "erreur",
    success: "succès",
    next: "prochain",
    previous: "précédent",
    submit: "soumettre",
    hours: "heure(s)",
    loading: "Chargement",
    coupon: "coupons",
    couponCode: "code promo",
    apply: "appliquer",
    reset: "réinitialiser",
    exam: "examen",
    exams: "examens",
    duration: "durée",
    myDashboard: "mon tableau de bord",
    pendingRequests: "demandes en attente",
    scheduledExams: "examens programmés",
    globalView: "vue globale",
    learners: "élèves",
    settings: "paramètres",
    application: "Application",
    download: "télécharger",
    camera: "caméra",
    approved: "approuvé",
    rejected: "rejetée",
    deleted: "Supprimé",
    approve: "approuvé",
    reject: "rejetée",
    banned: "banni",
    completed: "complété",
    pending: "en attente",
    deleted: "Deleted",
    username: "nom d'utilisateur",
    firstName: "prénom",
    lastName: "nom de famille",
    email: "adresse e-mail",
    birthDate: "date de naissance",
    learningInstitution: "établissement d'enseignement",
    learningInstitutions: "établissements d'enseignement",
    status: "statut",
    error: "Erreur",
    actions: "Actions",
    search: "recherche",
    close: "Close",
    sunday: "Dimanche",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    time: "heure",
    no: "Non",
    yes: "Oui",
    edit: "modifier",
    delete: "effacer",
    online: "en ligne",
    name: "nom",
    deactivate: "désactiver",
    activate: "Activate",
    view: "voir",
    date: "date",
    save: "sauvegarder",
    cancel: "annuler",
    submit: "Soumettre",
    dateAndTime: "Date et Heure",
    year: "année",
    softBooted: "retiré",
    flagged: "Signalé",
    confirm: "Confirmer",
    back: "arrière",
    accept: "accepter",
    decline: "rejeter",
    activate: "Activer",
    deactivate: "Deactivate",
    examName: "Nom de l’examen",
    eventLog: "Registre des événements",
    scheduling: "planifier",
    scheduledExams: "examens programmés",
    enter: "Entrer",
    total: "total",
    missingFieldsErrorMessage: "Remplir tous les champs en surbrillance",
    all: "Toute",
    title: "titre",
    fileUploader: "téléchargeur de fichier",
    active: "Actif",
    language: "Langue",
    formattedPrice: "{{ price }}$",
    deactivated: "Désactivé",
    limit: "Combien de fois un étudiant peut-il réserver ?",
    limitNotice: "Avis de limite",
    nextBooking: "Prochaine heure de réservation disponible:",
    book: "Book",
    note: "VEUILLEZ NOTER:",
    cancelled: "Annulé",
    request: "Demande",
    province: "Province",
    type: "Type",
    once: "Une fois",
    recurring: "Récurrent",
  },
  App: {
    dashboard: "Mon tableau de bord",
    accountDetails: "détails du compte",
    downloadApplication: "télécharger l'application",
    logout: "déconnection",
    loggingOut: "Fermeture de session...",
    accessDenied: "Accès refusé",
  },
  AccountDetails: {
    header: "détails du compte",
    whyWeNeedInfo: "Pourquoi nous avons besoin de vos informations",
    dataCollectionExplanation: "Nous recueillons vos renseignements personnels pour vérifier votre identité lors des examens surveillés, assurer l'intégrité des examens, prévenir la fraude et vous offrir une expérience de test sécurisée. Votre photo est requise pour la vérification d'identité, tandis que votre nom, date de naissance et adresse nous aident à confirmer votre identité. Vos informations de fuseau horaire et d'établissement d'enseignement garantissent que vous êtes programmé correctement et connecté aux bons examens. Toutes les informations sont stockées en toute sécurité et utilisées uniquement à des fins d'administration et de vérification d'examen. Pour plus d'informations, veuillez consulter notre",
    timezone: "fuseau horaire",
    selectTimezone: "Sélectionnez le fuseau horaire",
    learningInstitution: "établissement d'enseignement",
    selectLearningInstitution: "Sélectionnez un établissement d'enseignement",
    province: "Province",
    selectProvince: "Sélectionnez la province",
    dateOfBirth: "date de naissance",
    streetAddress: "adresse municipale",
    city: "ville",
    postalCode: "code postal",
    personalHeadshot: "plan du visage personnel",
    headshotPurpose: "Pourquoi nous avons besoin de votre photo",
    headshotExplanation: "Votre photo est requise pour la vérification d'identité pendant les examens surveillés afin d'assurer l'intégrité de l'examen et de prévenir la fraude. Votre photo est stockée en toute sécurité et utilisée uniquement à des fins de vérification d'examen. Pour plus d'informations, veuillez consulter notre",
    privacyPolicy: "Politique de confidentialité",
    addPersonalHeadshot:
      "Veuillez ajouter une photo d'identité avant de continuer.",
    completeProfileRequired: "Veuillez compléter les détails de votre compte (photo et établissement d'enseignement) avant de continuer.",
    saveAccountDetails: "enregistrer les détails du compte",
    backToDashboard: "Aller au tableau de bord",
    error: "Erreur",
    success: "Succès",
    invalidBirthdayFormat: "Format de date de naissance invalide. Veuillez utiliser le format AAAA-MM-JJ.",
    updatingError:
      "Une erreur s'est produite lors de la mise à jour des détails du compte.",
    updatingSuccess: "Votre compte a été mis à jour.",
    PST: "heure du Pacifique — heure avancée observée",
    MST: "heure des Rocheuses — heure avancée observée",
    CST: "heure du Centre — heure avancée observée",
    EST: "heure de l'Est — heure avancée observée",
    AST: "heure de l'Atlantique — heure avancée observée",
    NST: "heure de Terre-Neuve — heure avancée observée",
    AB: "Alberta",
    BC: "Colombie-Britannique",
    MB: "Manitoba",
    NB: "Nouveau-Brunswick",
    NL: "Terre-Neuve-et-Labrador",
    NT: "Territoires du Nord-Ouest",
    NS: "Nouvelle-Écosse",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Île-du-Prince-Édouard",
    QC: "Quebec",
    SK: "Saskatchewan",
    YT: "Yukon",
  },
  ExamDetails: {
    header: "Réservez un examen",
    examName: "Nom de l'examen",
    examPrice: "Prix de l'examen",
    examDetails: "Détails de l'examen",
    duration: "Durée de l’examen: {{duration}} heures",
    price: "prix",
    description: "description",
    notes: "Notes",
    tax: "taxe",
    discount: "réduction",
    datePending: "Date (en attente): ",
    creditCardNumber: "numéro de carte de crédit",
    creditCardExpiration: "Expiration de la carte de crédit",
  },
  SelectExam: {
    pageTitle: "Sélectionner un examen",
    header: "Réservez un examen",
    selectTrainingProvider: "Veuillez sélectionner un fournisseur de formation",
    selectExamProvider: "Veuillez sélectionner un fournisseur d’examen",
    selectExam: "Veuillez sélectionner un examen",
    selectType: "Veuillez sélectionner le type d'examen"
  },
  ConfirmBooking: {
    reviewConfirm: "Vérifier et confirmer",
    provinceMustBeSet:
      "La province doit être définie dans les détails du compte afin de traiter la commande.",
    confirmOrder: "confirmer la commande",
    pendingApproval:
      "Demande de réservation eProctor - En attente d'approbation",
    bookingError: "Impossible de traiter votre commande.",
    maxCapacity: "L'examen a atteint la capacité de réservation maximale.",
    unableBookTime: "Impossible de réserver pour l'heure spécifiée",
    dayBlocked: "Impossible de réserver pour le jour spécifié ",
    noFilesUploaded: "Aucun fichier téléchargé. ",
  },
  SelectDates: {
    pageTitle: "Sélectionner la date et l'heure",
    selectDate: "Veuillez sélectionner la date",
    fullyBooked: "Réservation complète",
    time: "Heure",
    defaultTimes: [
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
    ],
  },
  PaymentDetails: {
    couponNotValidForExam: "Coupon non valable pour l'examen",
    couponDoesNotExist: "Coupon inexistant",
    couponExpired: "Coupon expiré",
    pageTitle: "Détails de paiement",
    header: "détails de paiement",
    fileTooLargeError: "Le fichier doit être de 5 MO ou moins.",
    invalidFileTypeError: "Le fichier doit être de type jpeg ou png",
    couponError: "Erreur de coupon",
    couponApplied: "Coupon appliqué",
    couponAppliedMessage: "Le coupon a été appliqué avec succès.",
    expMonth: "Expiration - Mois",
    expYear: "Expiration - Année (2 chiffres)",
    ccv: "carte de crédit CVV2",
  },
  Receipt: {
    pageTitle: "Reçu",
    header: "Réserver un examen - Demande soumise",
    confirmEligibilityMessage: `Merci d'avoir planifié votre examen avec eProctor Canada. Votre demande d'examen a été reçue et sera examinée dans un délai de 2 jours ouvrables. Vous recevrez un courriel de confirmation une fois votre examen approuvé, moment auquel le paiement ci-dessous sera traité.`,
    downloadEproctorClientMessage: `Le jour de votre examen, téléchargez l'application eProctor au moins 30 minutes avant l'heure de début prévue. L'enregistrement s'ouvre 30 minutes avant votre examen - connectez-vous et sélectionnez votre examen pour commencer le processus d'enregistrement. Un surveillant vous rejoindra sous peu et vous donnera des instructions. Une fois l'enregistrement terminé, vous serez invité à commencer votre examen.`,
    questionsMessage: `Si vous avez des questions ou si vous souhaitez modifier cette demande, veuillez contacter support@eproctorcanada.com`,
    bookingDetails: "Détails de la réservation",
    orderDetails: "Détails de la commande",
  },
  BookExam: {
    step1Label: "Sélectionner l'examen",
    step2Label: "Sélectionner la date et l'heure",
    step3Label: "Détails de paiement",
    step4Label: "Réviser et confirmer la réservation",
    step5Label: "Confirmation",
    stepOf: "Étape {{current}} sur {{total}}",
  },
  Dashboard: {
    scheduledAdminLabel: "voir les examens programmés actuels et futurs",
    pendingRequestsAdminlabel:
      "Examiner et approuver les demandes d'examen en attente",
    examsAdminLabel: "voir, ajouter et modifier les examens pour les élèves",
    learnersAdminLabel: "reviser les détails des élèves",
    scheduleExams: "Planifier des examens",
    rescheduleAdminLabel: "reprogrammer et retirer les examens des élèves",
    settingsAdminLabel:
      "voir et modifier les paramètres de cet établissement d'enseignement",
  },
  StudentDashboard: {
    headshotRequired: "Photo de profil requise",
    headshotMessage: "Veuillez télécharger une photo personnelle avant de réserver des examens. Vous pouvez télécharger votre photo sur la page",
    accountDetailsLink: "Détails du compte",
  },
  EmailVerified: {
    success: "Votre adresse e-mail a été vérifiée",
  },
  ScheduledExams: {
    header: "examens programmés",
    welcome: "bienvenue",
    downloadApplication: "télécharger l'application",
    bookExam: "Réservez un examen",
    nextExam: "Prochain examen programmé",
    quickGuide: "Guide rapide",
    step1: "Téléchargez l'application le jour de votre examen et assurez-vous qu'elle est installée au moins 30 minutes avant l'heure de début prévue.",
    step2: "L'enregistrement ouvre 30 minutes avant votre examen. Connectez-vous et sélectionnez votre examen pour commencer le processus d'enregistrement.",
    step3: "Un surveillant vous rejoindra sous peu. Veuillez suivre leurs instructions pendant l'enregistrement.",
    step4: "Commencez votre examen une fois l'enregistrement terminé et lorsqu'on vous demande de procéder.",
    important: "Important",
    latestVersionNote: "Assurez-vous d'avoir la dernière version de l'application eProctor pour éviter les difficultés techniques.",
    startExam: "Prêt à commencer",
    upcomingExams: "Examens à venir",
    noExams: "Aucun examen programmé",
    cancelBooking: "Annuler l'examen",
    confirmCancelMore24: "Êtes-vous sûr de vouloir annuler cet examen? Parce que vous annulez plus de 24 heures avant l'heure de début, il n'y a pas de frais et vous recevrez un remboursement complet (si un paiement a été effectué). Cliquez sur Confirmer pour procéder à l'annulation.",
    confirmCancelLess24: "Êtes-vous sûr de vouloir annuler cet examen? Cette annulation a lieu dans les 24 heures de votre heure de début prévue. Aucun remboursement ne sera émis. Cliquez sur Confirmer pour continuer.",
    confirmButton: "Confirmer",
    cancelSuccess: "Réservation annulée avec succès",
    refundIssued: "Un remboursement complet sera traité dans un délai de 5 à 10 jours ouvrables et apparaîtra sur le mode de paiement original utilisé pour cette réservation.",
    noRefund: "Aucun remboursement ne sera émis en raison de l'annulation dans les 24 heures.",
    noChargeMade: "Aucun paiement n'a été perçu pour cette réservation, il n'y a donc rien à rembourser. Toute retenue sur la carte a été libérée.",
    cancelError: "Impossible d'annuler la réservation. Veuillez réessayer.",
    cancelErrorTitle: "Erreur",
    cancelErrorCheckedIn: "Impossible d'annuler la réservation après l'enregistrement ou la connexion à eProctor.",
    cancelErrorFinalState: "Impossible d'annuler une réservation déjà terminée, rejetée, bannie ou annulée.",
    cancelErrorNotAllowed: "Cet établissement n'autorise pas les annulations pour cet examen.",
    rescheduleExam: "Reprogrammer l'examen",
    rescheduleSuccess: "Examen reprogrammé avec succès",
    rescheduleError: "Impossible de reprogrammer la réservation. Veuillez réessayer.",
    rescheduleErrorTitle: "Erreur",
    rescheduleErrorCheckedIn: "Impossible de reprogrammer la réservation après l'enregistrement ou la connexion à eProctor.",
    rescheduleErrorFinalState: "Impossible de reprogrammer une réservation déjà terminée, rejetée, bannie ou annulée.",
    rescheduleErrorNotAllowed: "Cet établissement n'autorise pas la reprogrammation pour cet examen.",
    rescheduleErrorUnavailable: "Impossible de reprogrammer la réservation. L'heure sélectionnée pourrait ne pas être disponible.",
    rescheduleErrorWithin24Hours: "Impossible de reprogrammer une réservation dans les 24 heures précédant le début de l'examen.",
    requiresReapproval: "Le statut de votre réservation a été changé en attente et nécessitera une ré-approbation.",
  },
  GlobalView: {
    room: "salle",
    students: "élèves",
    proctor: "surveillant",
    noProctor: "Aucun surveillant assigné",
    noActiveRooms: "Il n'y a actuellement aucune salle active.",
  },
  ExamBlock: {
    examCompleted: "Cet examen est terminé",
    bookingApproved: "La réservation a été approuvée.",
    notPresentForExam: "Absence pour l'examen programmé",
    bookingRejected: "Réservation refusée",
    approvalTimeFrameMessage: `Votre examen sera approuvé dans un délai d'un jour ouvrable. Vous pouvez vous attendre à recevoir une notification par courriel après approbation.`,
    reschedule: "Reprogrammer",
    cancel: "Annuler",
  },
  PastExams: {
    header: "Réservations terminées",
    examTitle: "Titre de l'examen",
    date: "Date et heure",
    timezone: "Fuseau horaire",
    status: "Statut",
    noExams: "Aucun examen passé à afficher",
    cancelled: "Annulée",
  },
  ClientDownload: {
    header: "télécharger l'application",
    instructionsStepOne:
      "Sélectionnez et téléchargez l’application pour votre système",
    instructionsStepTwo: `Ouvrez l’application et sélectionnez l’examen programmé à écrire.`,
    instructionsStepThree: `Suivez les instructions à mesure qu’elles sont présentées pour atteindre eProctor Canada. Vos identifiants de connexion pour eProctor Canada et le système du fournisseur d’examens (p. ex., PSKN) sont requis`,
    systemRequirements: "configuration minimale requise",
    networkRequirements: "exigences de réseau",
    uploadSpeed: "vitesse de téléchargement",
    downloadSpeed: "vitesse de téléchargement",
    minUploadSpeed: "minimum de 2.5 Mbits/s",
    minDownloadSpeed: "minimum de 2.5 Mbits/s",
    computerRequirements: "spécifications de l'ordinateur requises",
    webcamWithMicrophone: "Webcam avec microphone (ou microphone séparé)",
    windows: "Windows",
    minWindowsVersion: "Windows 10 ou une version supérieure",
    mac: "Mac",
    minMacVersion: "OS X 11 ou une version supérieure",
    downloadMessage: "Votre téléchargement devrait commencer automatiquement.",
    didntWork: "Ça n’a pas marché ? Cliquez <1>ici</> et réessayez",
    applicationDownload: "téléchargement de l'application",
  },
  PendingRequests: {
    receiptEmailSubject: "Reçu d’achat eProctor - Réservation confirmée",
    bookingConfirmedEmail: "Confirmation de la réservation eProctor",
    bookingRejectedEmail: "Demande d’examen eProctor - Rejetée",
    submittedDate: "Date de soumission",
    bookingDate: "date de réservation",
    downloadFile: "télécharger le fichier",
    paymentError: "Erreur de paiement",
  },
  RejectModal: {
    rejectBooking: "Rejeter la réservation",
    rejectReasoning: "raison du rejet",
    chargedBookingWarningTitle: "L'utilisateur a déjà été facturé",
    chargedBookingWarningBody:
      "Cet utilisateur a déjà été facturé pour cette réservation. Le rejet entraînera un remboursement complet sur sa carte.",
  },
  RescheduleDates: {
    sendUserNotification:
      "Souhaitez-vous envoyer à l’utilisateur une notification des modifications ?",
  },
  Exam: {
    errorAddingHeader: "Erreur d’ajout d’examen",
    daysAvailable: "jours disponible",
    days: "Jours",
    timesAvailable: "heures disponible",
    capacity: "capacité",
    cost: "coût",
    addExam: "Ajouter un examen",
    notApplicable: "ne s'applique pas",
    enableFileUpload: "Activer le téléchargement de fichiers (certificats)",
    checkinScript: "Règles / texte d'enregistrement du surveillant",
    studentRules: "Règles pour les étudiants",
    uploadDescription: "télécharger la description",
    from: "de",
    to: "à",
    limit: "limite",
    examFrequency: "Fréquence des examens",
  },
  ExamTable: {
    deleteExam: "Supprimer un examen",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet examen?",
    confirmCancel: "Êtes-vous sûr de vouloir annuler cette réservation?",
    learningInstitutions: "Établissement(s) d’enseignement",
    added: "ajouté",
    bookingLimit: "Limite de réservation",
  },
  RescheduleExam: {
    header: "Reporter l’examen",
    resheduleEmailSubject: "Réservation eProctor reproctor reprogrammée",
    dateAndTimeSlot: "Créneau horaire et date",
    reschedule: "Reporter",
    deleteBooking: "Supprimer une réservation",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer?",
    showFutureBookings: "Afficher uniquement les réservations futures",
    cancelExam: "Annuler l'examen",
    cancelWithRefund: "Annuler (Avec remboursement)",
    cancelNoRefund: "Annuler (Sans remboursement)",
    cancelExamWithRefundMsg: "Êtes-vous sûr de vouloir annuler cette réservation? L'utilisateur recevra un remboursement complet.",
    cancelExamNoRefundMsg: "Êtes-vous sûr de vouloir annuler cette réservation? Aucun remboursement ne sera émis.",
    refunded: "Remboursé",
    refundedYes: "Oui",
    refundedNo: "Non",
  },
  Learners: {
    replays: "Replays",
    registeredOn: "enregistrée le",
    replays: "rejouer",
    viewBookings: "View Bookings",
  },
  LearnerBookings: {
    bookingsFor: "Bookings for",
    recordings: "Recordings",
    confirmRequestRecordings: "Request the following recordings?",
    requestDownloadAgain: "Request Failed. Try Again?",
  },
  InstitutionsTable: {
    addInstitution: "Ajouter une institution",
    institution: "Institution",
    addOrEditInstitution: "Ajouter/modifier une institution",
    errorAddingClient: "Erreur d’ajout du client",
    institutionName: "Nom de l’institution",
    pointOfContactName: "point de contact",
    pointOfContactEmail: "email du contact",
    availabilityStatus: "statut de disponibilité",
    pointOfContact: "Point de contact",
    contactEmail: "email du contact",
    allowRescheduling: "Reprogrammation / Annulation",
    allowStudentsToRescheduleOrCancel: "Permettre aux étudiants de reprogrammer ou d'annuler",
    allowReschedulingColumn: "Reprogrammation permise",
  },
  BlockedDays: {
    header: "Jours bloqués",
    addBlockedDay: "Ajouter une journée bloquée",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette journée bloquée?",
    missingFieldsError: "Veuillez indiquer le nom et la date.",
    everyYearLabel: "La date doit être bloquée chaque année",
    everyYear: "chaque année",
    allDay: "Toute la journée",
    allDayLabel: "Toute la journée?",
    times: "Créneau horaire à bloquer",
    overlapError:
      "Les jours bloqués se chevauchent avec les jours/créneaux horaires bloqués existants pour des examens donnés.",
  },
  ExamSchedule: {
    createRoom: "créer une salle",
  },
  ProctoringSession: {
    expandView: "Vue élargie",
    cycleMaxUsers: "Nombre maximal d’utilisateurs du cycle",
    faceToFaceDisconnected: "L’utilisateur s’est déconnecté du face a face",
    faceToFaceConnected: "Vous êtes maintenant connecté",
    joinedSession: "rejoint la séance ",
    noLearnersInExam: "Personne dans l’examen en ce moment",
    monitorWarningMessage: "Utilisateur a des moniteurs :",
    noLearnersInExamMessage:
      "Nous vous ferons savoir quand quelqu’un se joindra à nous.",
    pushExamUrl: "Envoyer l’URL de l’examen",
    url: "URL",
    pushExam: "Envoyer l'examen",
    pushExamAllUsers: "Envoyer l’examen à tous les utilisateurs",
    lostConnection: "Lost Connection",
    reJoinedSession: "Rejoined Session",
  },
  WebCamUser: {
    minimize: "Minimiser",
    maximize: "Maximiser",
    ban: "Interdiction",
    signOut: "Fermeture de session",
    flag: "signaler",
    singleLink: "Lien unique",
    linkAll: "Lier tout",
    banUser: "Bannir l’utilisateur",
    confirmBan: "Est-il acceptable de bannir",
    softBanUser: "Utilisateur de démarrage logiciel",
    confirmSoftBoot: "Est-il acceptable de retiré",
    callLearner: "Appeler l'étudiant",
    userDisconnectedHeader: "Connection Lost",
    userDisconnectedMessage: "Attempting to restablish connection.",
    refresh: "Rafraîchir",
    moveToRoom: "Déplacer vers une salle",
  },
  Checkin: {
    learnerRejoinedHeader: "l'étudiant a rejoint",
    learnerRejoinedMessage: "l'étudiant a rejoint l'enregistrement",
    learnerLeftHeader: "l'étudiant est parti",
    learnerLeftMessage: `l'étudiant a quitté la zone d'enregistrement ou a des problèmes de réseau.`,
    webcamNotReadableHeader: "Webcam non lisible",
    webcamNotReadableMessage: `Impossible d’accéder à la webcam du procteur. Veuillez vous assurer que la webcam n’est pas utilisée par un autre programme.`,
    checkinScript: "Script d’enregistrement",
    noRules: "Aucune règle pour l’examen.",
  },
  Chat: {
    proctor: "(Procteur)",
    typeMessageHere: "Ecrire message ici",
  },
  CheckinQueue: {
    header: "File d’attente d’enregistrement",
    clientVersion: "Version client",
    checkIn: "Enregistrement",
    noRoomsAvailable: "Aucune salle disponible",
    moveUser: "Déplacer l’utilisateur",
    noUsersInRoom: "Aucun utilisateur dans cette salle.",
    deleteRoom: "Supprimer la salle",
  },
  CouponTable: {
    over100Error: "Le coupon ne peut pas dépasser 100 %.",
    addCoupon: "Ajouter un coupon",
    addOrEditCoupon: "Ajouter/modifier un coupon",
    missingFieldsErrorHeader: "Erreur d’ajout d’un coupon",
    couponCode: "code promo",
    couponValue: "valeur du coupon",
    couponValueType: "Type de valeur du coupon",
    valueType: "Type de valeur du coupon",
    selectExams: "Veuillez sélectionner un examen",
    maxUses: "Nombre d’utilisations maximal",
    availabilityStatus: "statut de disponibilité",
    value: "valeur",
    exams: "Examen(s)",
    maxUses: "Utilisations maximales",
    timesUsed: "nombre de fois utilisées",
    deactivateCoupon: "Désactiver le coupon",
    activateCoupon: "Activer le coupon",
    deactivateCouponConfirm: "Êtes-vous sûr de vouloir désactiver ce coupon?",
    activateCouponConfirm: "Êtes-vous sûr de vouloir désactiver ce coupon?",
  },
  JoinExamModal: {
    joinAnExam: "Joindre un examen",
    join: "Joindre",
    leaveExam: "Quitter l’examen",
    joinExam: "Se joindre à l’examen",
  },
  CreateRoom: {
    addRoom: "Ajouter une salle",
    roomTitle: "Titre de la salle",
    dateAndTime: "Date et heure",
    submit: "Soumettre",
  },
  PictureUploader: {
    uploadFile: "Télécharger le fichier",
    clickToUpload: "Cliquez ici pour télécharger.",
    dragDropText: "ou glissez-déposez votre image ici",
    imageLoaded: "Image chargée avec succès",
    uploadButton: "Choisir et télécharger l'image",
    fileRequirements: "PNG ou JPEG, max 5 Mo",
    fileTooLargeError: "Le fichier doit être de 5 MO ou moins.",
    incorrectFileTypeError: "Le fichier doit être de type JPEG ou PNG",
    text: "cliquez sur la case pour télécharger le plan du visage",
  },
  Emails: {
    emailSubject: "Objet du courriel",
    supportCenter: "Centre de soutien eProctor",
    tollFree: "Sans frais",
    BookingApproval: {
      header: "Réservation confirmée pour {{ examTitle }}",
      message: `Votre examen au {{ bookingDate }} {{ timezone }} a été approuvé. Veuillez porter particulièrement attention aux points suivants :`,
      timezoneWarning: `Assurez-vous que le fuseau horaire de votre ordinateur et de votre compte eProctor correspond à votre emplacement actuel. (Par exemple, si vous êtes en Alberta, votre fuseau horaire devrait être l'heure des Rocheuses.) Vous pouvez vérifier ou mettre à jour ce paramètre dans vos « Paramètres du compte ».`,
      preExamInstructions: `Avant de passer votre examen, effectuez un
            <1>test de vitesse</1>  à l’endroit où vous prévoyez d'écrire pour vous assurer que vos vitesses Internet répondent aux
            <3>
              exigences du système
            </3>
            eProctor Canada.`,
      downloadLatestClient: `Le jour de votre examen, téléchargez la dernière version de
            <1>
              l’application eProctor Canada.
            </1>
            Si vous n’avez pas la dernière version de l’application, vous ne pourrez pas accéder à l’examen.`,
      checkinTime: `30 minutes avant votre examen, connectez-vous à l'application eProctor pour terminer le processus de validation et d'enregistrement.`,
      lateWarning: `Si vous avez plus de 15 minutes de retard, vous ne serez pas autorisé à passer l’examen.`,
      examDuration_one: "Durée de l'examen: {{duration}} heure",
      examDuration_other: "Durée de l'examen: {{duration}} heures",
      examRules: "Règles spécifiques à l’examen: {{ examRules }}",
    },
    BookingRejected: {
      header: "Demande de réservation eProctor - Rejetée",
      invoiceNumber: `invoice #: {{invoiceNumber}}`,
      message: `Demande de réservation pour {{ name }} pour prendre {{ examTitle }}
             a été rejeté`,
      reason: "Raison fournie: {{ reason }}",
      refundNoticeTitle: "Traitement du remboursement",
      refundNotice: "Votre remboursement sera traité dans un délai de 5 à 10 jours ouvrables et apparaîtra sur le mode de paiement original utilisé pour cette réservation.",
      noChargeTitle: "Aucun paiement perçu",
      noChargeNotice: "Cette réservation a été rejetée avant qu'aucun paiement ne soit perçu. Si une retenue temporaire avait été placée sur votre carte, elle a déjà été libérée - vous devriez la voir annulée dans un délai de 5 à 10 jours ouvrables, selon votre banque, et aucun frais n'apparaîtra sur votre relevé.",
      supportContact: `Pour obtenir de plus amples renseignements, veuillez contacter le Centre de soutien eProctor par email à support@eproctorcanada.com ou par téléphone au 1-844-595-2561.`,
    },
    BookingRequest: {
      header: "Demande de réservation pour {{ examTitle }} En attente",
      bookingCode: "Code de réservation: {{ code }}",
      approvalTimeFrame:
        "Veuillez noter que la réservation d’un examen peut prendre jusqu’à 2 jours ouvrables.",
      postApprovalInstructions: `Une fois votre examen approuvé, vous recevrez une notification par email avec votre confirmation de paiement.  Si vous avez des questions, veuillez contacter le Centre de soutien eProctor par email à support@eproctorcanada.com ou par téléphone au 1-844-595-2561.`,
    },
    BookingReschedule: {
      header: "Reprogrammation de réservation confirmée pour {{examTitle}}",
      message: `{{ name }}, Votre examen précédent a été reporté à
            {{ bookingDate }} {{ timezone }}.  Veuillez vous connecter à votre compte eProctor 30 minutes avant l’examen pour terminer le processus de validation et d’enregistrement.`,
      duration_one: "Durée de l'examen: {{duration}} heure",
      duration_other: "Durée de l'examen: {{duration}} heures",
      examRules: "Règles spécifiques à l’examen: {{ examRules }}",
      defaultRules:
        "En plus de ce qui précède, veuillez préparer ce qui suit :",
      ruleOne: `L’étudiant doit rester dans la salle d’examen jusqu’à la fin de l’examen. Les pauses toilettes ne sont pas permises.`,
      ruleTwo:
        "Assurez-vous que la zone d’examen est calme et qu’il n’y a pas de distractions.",
      ruleThree: `Aucun téléphone cellulaire, y compris les montres intelligentes et autres appareils électroniques, n’est autorisé dans la zone au moment de l’examen.`,
      ruleFour: "Carte d’identité avec photo émise par le gouvernement",
    },
    EmailReminder: {
      header: "Rappel d’examen eProctor - {{ examTitle }}",
      message: `Cette note a pour but de vous rappeler votre examen prévu avec eProctor.`,
      examDate: "{{ examTitle }} on {{ date }}",
      checkinInstructions: `vous pouvez commencer le processus d’enregistrement 30 minutes avant l’heure de l’examen.  Les éléments suivants seront requis lors de l’enregistrement:`,
      checkinRequirementOne: "Carte d’identité avec photo",
      loginCredentialsMessage:
        "Identifiants de connexion (nom d’utilisateur et mot de passe) pour votre système d’examen hôte (PSKN)",
    },
    PurchaseReceipt: {
      header: "eProctor - Merci pour votre commande.",
      invoiceNumber: "facture #",
      businessNumber: "Business #808349930RT0001",
    },
    UserRegistration: {
      welcome: "Bienvenue sur eProctor",
      welcomeMessage: `Bienvenue à eProctor, le meilleur fournisseur d’examen en ligne au Canada. Pour planifier votre examen, veuillez 
        consulter le site http://eproctorcanada.com.  Pour plus d'information ou pour obtenir du soutien technique, veuillez contacter 
        support@eproctorcanada.com ou composer le 1-844-595-2561.`,
    },
    BookingCancelled: {
      subjectWithRefund: "Réservation annulée - Remboursement émis",
      subjectNoRefund: "Réservation annulée",
      headerWithRefund: "Réservation annulée - Remboursement émis",
      headerNoRefund: "Réservation annulée",
      messageWithRefund: "Votre réservation pour {{ examTitle }} prévue le {{ bookingDate }} {{ timezone }} a été annulée avec succès.",
      messageNoRefund: "Votre réservation pour {{ examTitle }} prévue le {{ bookingDate }} {{ timezone }} a été annulée avec succès.",
      cancellationDetails: "Détails de l'annulation",
      examName: "Nom de l'examen",
      scheduledDate: "Date et heure prévues",
      duration: "Durée",
      refundStatus: "État du remboursement",
      refundApproved: "Remboursement approuvé",
      noRefund: "Aucun remboursement",
      refundAmount: "Montant du remboursement",
      refundNoticeTitle: "Traitement du remboursement",
      refundNotice: "Votre remboursement sera traité dans un délai de 5 à 10 jours ouvrables et apparaîtra sur le mode de paiement original utilisé pour cette réservation.",
      noRefundTitle: "Politique d'annulation",
      noRefundNotice: "Cette annulation a eu lieu dans les 24 heures précédant l'heure prévue de votre examen. Selon notre politique d'annulation, aucun remboursement ne sera émis pour les annulations effectuées dans ce délai.",
      noChargeMade: "Aucun frais n'a été prélevé",
      noChargeTitle: "Aucun paiement perçu",
      noChargeNotice: "Cette réservation a été annulée avant qu'aucun paiement ne soit perçu. Si une retenue temporaire avait été placée sur votre carte, elle a déjà été libérée - vous devriez la voir annulée dans un délai de 5 à 10 jours ouvrables, selon votre banque, et aucun frais n'apparaîtra sur votre relevé.",
      closingWithRefund: "Nous sommes désolés de voir que vous annulez votre examen. Si vous souhaitez réserver un autre examen à l'avenir, veuillez consulter notre site Web.",
      closingNoRefund: "Nous sommes désolés de voir que vous annulez votre examen. Si vous souhaitez réserver un autre examen à l'avenir, veuillez consulter notre site Web.",
      questions: "Si vous avez des questions ou des préoccupations, veuillez nous contacter.",
    },
  },
};

export default fr;
